<template>
	<!-- 登录页 -->

	<div class="login-wrap ">
		<img :src="require('../../assets/img/'+configimg)" class="lefticon" v-if="notemptyandnull(configimg)" />
		<div class="Verticalcenter" style="width: 100%;height: 100%;">
		<!-- 头部 -->
		<el-dialog title="忘记密码/Forget" :visible.sync="forgetdiag" :close-on-click-modal="false" append-to-body v-dialogDrag>
			<el-form :model="forgetparam" ref="forgetparam" :rules="forgetrules" label-width="0px">
				<div class="Verticalcenter-line forgetall">
					<div>
						<img src="../../assets/img/forget1.png" />
						<el-form-item prop="username"><el-input v-model="forgetparam.username" placeholder="请输入用户名" class=""></el-input></el-form-item>
					</div>
					<div>
						<img src="../../assets/img/forget2.png" />
						<el-form-item prop="phone"><el-input v-model="forgetparam.phone" placeholder="请输入注册手机号" class=""></el-input></el-form-item>
					</div>
					<div>
						<img src="../../assets/img/forget3.png" />
						<el-form-item prop="code">
							<div class="forgetstyle" @click="sendforgetSMS">
								<span v-show="showforget">获取验证码</span>
								<span v-show="!showforget" class="count">{{ countforget }} s</span>
							</div>
							<el-input v-model="forgetparam.code" placeholder="请输入验证码" class=""></el-input>
						</el-form-item>
					</div>
					<div>
						<img src="../../assets/img/forget4.png" />
						<el-form-item prop="password"><el-input v-model="forgetparam.password" type="password" placeholder="请输入新密码" class=""></el-input></el-form-item>
					</div>
					<div>
						<img src="../../assets/img/forget5.png" />
						<el-form-item prop="surepassword"><el-input v-model="forgetparam.surepassword" type="password" placeholder="请再次输入密码" class=""></el-input></el-form-item>
					</div>
				</div>
			</el-form>
			<div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<div class="rightbuttom">
					<div @click="forchoose">确定</div>
					<div @click="forgetdiag = false">取消</div>
				</div>
			</div>
		</el-dialog>
		<div style="display: flex;justify-content: center; align-items: center; ">
			<div class="top-header">
				<div>{{title}}</div>
				<div>{{englishtitle}}</div>
				<img src="../../assets/img/logimg.png" />
			</div>
			<div class="line" style="width:1px;height: 300px;background-color: #3f5063;margin-left: 60px;"></div>
			<div style="margin-left: 30px;">
				<div style="color: #FFFFFF; font-size: 18px;margin-bottom: 30px;">登录/Login</div>
				<div>
					<el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
						<!-- 用户名 -->
						<div style="display: flex;">
							<img src="../../assets/img/loginicon3.png" class="imgicon" />
							<el-form-item prop="userCode"><el-input v-model="param.userCode" placeholder="请输入用户名" class="elinput"></el-input></el-form-item>
						</div>
						<!-- 密码 -->
						<div style="display: flex;margin-top: 10px;">
							<img src="../../assets/img/loginicon6.png" class="imgicon" />
							<el-form-item prop="password">
								<el-input class="elinput" type="password" v-model="param.password" placeholder="请输入密码">
									<!-- <el-button  slot="prepend" icon="el-icon-lx-lock"></el-button> -->
								</el-input>
							</el-form-item>
						</div>
						<!-- 图文验证 -->
						<div style="display: flex;margin-top: 10px;">
							<img src="../../assets/img/loginicon5.png" class="imgicon" />
							<el-form-item prop="sign">
								<div class="codestyle" @click="sendSMS">
									<span v-show="show">获取验证码</span>
									<span v-show="!show" class="count">{{ count }} s</span>
								</div>
								<el-input class="elinput" type="verify" placeholder="请输入验证码" v-model="param.sign" @keyup.enter.native="onSubmit('param')"></el-input>
							</el-form-item>
						</div>
						<div class="forforget">
							<div>
								<div>还没有账号?</div>
								<div class="forforget-regist" @click="forRegister()">立即注册</div>
							</div>
							<div @click="toforget" style="cursor: pointer;">忘记密码</div>
						</div>
					</el-form>
				</div>
				<div class="forlogin" @click="submitForm()">
					登录
				</div>
<!--				<div class="otherhref" @click="foryunyinng">
					运营平台登录>>
				</div>-->
			</div>
		</div>
		<div class="banan"><a style='color: ghostwhite;'  href='https://beian.miit.gov.cn' target='_blank'>{{beianhao}}</a></div>
		</div>
	</div>
</template>

<script>
import { userLogin } from '../../api/index';
import Sidentify from '../common/identify';
import configHttp from '../../../configHttp.js'
//var Base64 = require('js-base64').Base64
export default {
	name: 'Login',
	components: {
		Sidentify
	},
	data: function() {
		var validatePass = (rule, value, callback) => {
		      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>,.\/])(?=.*[0-9]).{8,}$/;
		      if(value==''){
		        callback(new Error('请输入密码'));
		      } else   if (!reg.test(value)) {
		        callback(new Error('密码需包含大小写字母、特殊符号、数字且大于8位'));
		      } else {
		        callback();
		      }
		    };
		return {
			forgetdiag: false,
			show: true,
			showforget: true,
			count: '',
			countforget: '',
			timer: null,
			timerforget: null,
			forgetparam: {
				username: '',
				phone: '',
				code: '',
				password: '',
				surepassword: ''
			},
			param: {
				userCode: '',
				password: '',
				sign: ''
			},
			rules: {
				userCode: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				sign: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			forgetrules: {
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
				code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				password: [{  trigger: 'blur',validator: validatePass }],
				surepassword: [{ required: true, message: '请再次输入密码', trigger: 'blur' }]
			},
			title:"",
			englishtitle:"",
			beianhao:"",
			configimg:"",
			projectName: "",
			enableFamilyLogin: "",
			familyLoginUrl: ""
		};
	},
	created() {
		
		this.title=configHttp.title
		this.englishtitle=configHttp.englishtitle
		this.beianhao=configHttp.beianhao
		this.configimg=configHttp.img
		this.projectName=configHttp.projectName
		this.enableFamilyLogin=configHttp.enableFamilyLogin
		this.familyLoginUrl=configHttp.familyLoginUrl
		this.projectName.toUpperCase()
		// 保留单点登录来的session
        let sessionId = localStorage.getItem("sessionId")
		localStorage.clear();
        localStorage.setItem("sessionId",sessionId)
		
		if(this.projectName == "WGQ") { // 外高桥单点登录跳转
			this.ssoRedirect();
		}	
	},
	methods: {
		foryunyinng(){
			location.href=configHttp.hrefurl
		},
		sendforgetSMS() {
			if (this.forgetparam.username == '') {
				this.$message.error('请输入用户名');
				return false;
			}
			if (this.forgetparam.phone == '') {
				this.$message.error('请输入手机号');
				return false;
			}
			if (!this.showforget) {
				return false;
			}
			let param = {};
			param.userCode = this.forgetparam.username;
			param.phone = this.forgetparam.phone;
			this.$https.fetchPost('/sys/sendSmsByUserCodeAndPhone', param).then(
				res => {
					if (res.data.success) {
						this.getforgetCode();
					}
				},
				error => {
					this.$message.error('发送忘记密码校验码错误：' + error);
				}
			);
		},
		getforgetCode() {
			const TIME_COUNT = 60;
			if (!this.timerforget) {
				this.countforget = TIME_COUNT;
				this.showforget = false;
				this.timerforget = setInterval(() => {
					if (this.countforget > 0 && this.countforget <= TIME_COUNT) {
						this.countforget--;
					} else {
						this.showforget = true;
						clearInterval(this.timerforget);
						this.timerforget = null;
					}
				}, 1000);
			}
		},
		forchoose() {
			this.$refs['forgetparam'].validate(valid => {
				if (valid) {
					if (this.forgetparam.password != this.forgetparam.surepassword) {
						this.$message.info('两次新密码不一致。');
						return;
					}
					let param = {};
					param.userCode = this.forgetparam.username;
					param.phone = this.forgetparam.phone;
					param.checkCode = this.forgetparam.code;
					param.currentPassword = this.forgetparam.password;
					this.$https.fetchPost('/sys/forgetPassword', param).then(
						res => {
							if (res.data.success) {
								this.forgetdiag = false;
							}
						},
						error => {
							this.$message.error('修改密码错误：' + error);
						}
					);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		toforget() {
			Object.keys(this.forgetparam).map(key => (this.forgetparam[key] = ''));
			this.forgetdiag = true;
		},

		/* 获取验证码 */
		sendSMS() {
			if (this.param.userCode == '') {
				this.$message.error('请输入用户名');
				return false;
			}
			if (!this.show) {
				return false;
			}
			let params = {
				userCode: this.param.userCode
			};
			this.$https.fetchPost('sys/sendSms', params).then(res => {
				if (res.data.success) {
					this.getCode();
				}
			});
		},

		/* 验证码倒计时 */
		getCode() {
			const TIME_COUNT = 60;
			if (!this.timer) {
				this.count = TIME_COUNT;
				this.show = false;
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--;
					} else {
						this.show = true;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
			}
		},
		//图形验证码
		forhref(e) {
			if (e == 'fpt') {
				window.location.href = 'https://vat.taxunion.net/';
			}
			if (e == 'pbd') {
				window.location.href = 'https://exp.taxunion.com.cn/';
			}
		},
		/* 	获取用户展示权限菜单 */
		getCurrentUserMenuFunction() {
			let params = {};
			this.$https.fetchPost('sys/admin/getRoleMenuIdListByUser', params).then(res => {
				if (res.data.success) {
					localStorage.setItem('routearr', res.data.obj.routearr);
					localStorage.setItem('userFunction', JSON.stringify(res.data.obj.userFunction));
                    this.saveStorageButton(res.data.obj.userFunction);
					this.$router.push('/');
				}
			});
		},
        saveStorageButton(data){
            let buttonIds = [];
            let userFunction = data;
            for (let i = 0; i < userFunction.length; i++) {
                if (userFunction[i].hasOwnProperty("children")) {
                    let pageButtons = userFunction[i].children;
                    for (let j = 0; j < pageButtons.length; j++) {
                        if (pageButtons[j].hasOwnProperty("buttomroute")) {
                            let keys= Object.keys(pageButtons[j].buttomroute);
                            if (keys.length <= 0){continue}
                            let buttonObjs = pageButtons[j].buttomroute;
                            for (let key of keys) {
                                buttonIds.push(key);
                                let btnKeys= Object.keys(buttonObjs[key]);
                                if (btnKeys.length <= 0){continue}
                                for (let btnKey of btnKeys) {
                                    if (buttonObjs[key][btnKey]) {
                                        buttonIds.push(btnKey);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            localStorage.setItem('buttonIds', JSON.stringify(buttonIds));
        },
		/* 登陆 */
		submitForm() {
			let params = this.param;
			if (params.userCode == '' || params.password == '') {
				this.$message.error('请输入账号和密码');
				return false;
			}
			/*if(params.sign == ''){
                this.$message.error('请输入验证码');
                return false;
            }*/
      params.password=this.encryptionPasswordAes(params.password);
			this.$https.fetchPost('sys/login', params).then(res => {
				if (res.data.success) {
					localStorage.setItem('token', res.data.obj.token);
					localStorage.setItem('useropj', res.data.obj.user);
					localStorage.setItem('portalLogin',"false");
					this.getCurrentUserMenuFunction();
				}
			});
		},
		forRegister() {
			this.$router.push('/register');
		},
        async ssoRedirect(){	// 外高桥单点登录
			this.getRequestParam().then(requestParam => {
				let newsessionId = requestParam['session'];
				console.log("newsessionId : " + newsessionId)
				if (newsessionId && newsessionId.length > 0){
					localStorage.setItem('sessionId', newsessionId);
				}else {
					newsessionId = localStorage.getItem('sessionId')
				}
				
				if (newsessionId && newsessionId != "null"){
					console.log("newsessionId : " + newsessionId)
					this.$https.fetchPost('sso/getUserData?sessionId=' + newsessionId).then(res => {
						if (res.data.success) {
							localStorage.setItem('token', res.data.obj.token);
							//localStorage.setItem('useropj', JSON.stringify(res.data.obj.user));
                            localStorage.setItem('useropj', res.data.obj.user);
							this.getCurrentUserMenuFunction();
						}
					});
				}else {
					this.$https.fetchPost('sso/getHost').then(res => {
						window.location.href = res.data
					});
				}
			});
		},
		async getRequestParam() {   //  获取请求后面的参数
			var requestParam = new Object();
			if(location.href.indexOf('?') != -1) {
				var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
				var str = url.substr(1);
				let strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
				}
			}
			return requestParam;
		}
	}
};
</script>

<style scoped>
@media screen and (max-width: 1441px) {
    .lefticon{
    	width: 134.4px;
    	height: 54.8px;
    	left: 20px;
    	top: 20px;
    	position: absolute;
    }
}
@media screen and (min-width: 1441px) {
    .lefticon{
    	width: 168px;
    	height: 68.5px;
    	left: 80px;
    	top: 80px;
    	position: absolute;
    }
}
	
	.forlogin{
		width: 416px;
		height: 46px;
		cursor: pointer;
		background: #3198FF;
		margin-left: 10px;
		border-radius: 27px;
		margin-top: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-family: 'PingFang SC';
		font-weight: 400;
		color: #FFFFFF;

	}
	.otherhref{
		font-size: 12px;
		font-family: 'PingFang SC';
		font-weight: 500;
		color: #FFFFFF;
		display: flex;
		cursor: pointer;
		justify-content: flex-end;
		margin-top: 20px;
	}
	.banan{
		position: fixed;
		color: white;
		font-size: 14px;
		bottom: 10px;
		opacity: 0.3;
	}
.forforget {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	margin-left: 50px;
	font-family: 'PingFang SC';
	color: #ffffff;
}
.forforget > div {
	display: flex;
	align-items: center;
}
.forforget-regist {
	color: #0078ff;
	cursor: pointer;
	margin-left: 10px;
}
.top-header {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.top-header > img {
	width: 480px;
	height: 340px;
}
.top-header > div {
	font-size: 36px;
	font-family: 'PingFang SC';
	font-weight: 400;
	color: #ffffff;
	opacity: 1;
}
.top-header > div:nth-of-type(2) {
	font-size: 24px;
	margin-top: 10px;
	font-family: 'PingFang SC';
	font-weight: 300;
	letter-spacing: 3px;
	opacity: 0.7;
	color: #ffffff;
}
.hidden-now {
	visibility: hidden;
}
.img-b > div {
	width: 80px;
	height: 80px;
	cursor: pointer;
}
.img-b > div > img {
	width: 100%;
	height: 100%;
}
.codestyle {
	width: 100px;
	height: 30px;
	background: #ffffff;
	margin-bottom: 13px;
	margin-left: 260px;
	border-radius: 3px;
	z-index: 99;
	display: flex;
	align-items: center;
	cursor: pointer;
	justify-content: center;
	position: absolute;
}
.codestyle > span {
	font-size: 12px;
	color: #233045;
}
/deep/.el-input__inner {
	width: 360px;
	border: 0px !important;
	background-color: #233045;
	color: white;
}

.imgicon {
	width: 36px;
	height: 36px;
	margin-right: 10px;
}

/deep/.el-input--small {
	border: 0px !important;
}
.elinput {
	border-bottom: 1px solid #3f5063 !important;
	
	/* border-bottom: 2px solid #FFFFFF!important; */
}

.login-wrap {
	width: 100%;
	height: 100%;
	background-color: #233045;
}
.forgetall > div {
	display: flex;
}
.forgetall > div > img {
	width: 25px;
	height: 30px;
	margin-right: 30px;
}

.forgetall /deep/.el-input__inner {
	width: 276px;
	background-color: #ffffff;
	font-size: 13px;
	border-radius: 0px;
	padding: 0px;
	font-family: 'PingFang SC';
	font-weight: 500;
	color: #535f6d;
	border-bottom: 1px solid #e5e5e5 !important;
}
.ms-content /deep/.el-input__inner {
	
	padding: 0px;
	outline: none;
	
}
.forgetstyle {
	width: 77px;
	height: 25px;
	border: 1px solid #233045;
	border-radius: 2px;
	font-size: 13px;
	font-family: 'PingFang SC';
	margin-left: 191px;
	font-weight: 500;
	color: #233045;
	display: flex;
	cursor: pointer;
	justify-content: center;
	align-items: center;
	position: absolute;
	z-index: 99;
}
</style>
